import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, ForkKnife, SignIn } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";

export default function DeleteAccount() {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();
  const deleted = params.get("deleted") === "1";

  const loginForDeletion = () => {
    const redirectUrl = `${window.location.origin}/app/cuenta`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen" data-testid="public-delete-account-page">
      <header className="max-w-4xl mx-auto px-6 py-6">
        <Link to="/" className="inline-flex items-center gap-2" data-testid="delete-page-brand-link">
          <ForkKnife size={24} weight="duotone" className="text-[hsl(var(--primary))]" />
          <span className="font-serif text-xl">MIZETA</span>
        </Link>
      </header>

      <main className="max-w-4xl mx-auto px-6 pt-12 pb-24">
        {deleted ? (
          <section className="max-w-2xl fade-up" data-testid="account-deleted-confirmation">
            <CheckCircle size={40} weight="duotone" className="text-[hsl(var(--secondary))]" />
            <h1 className="font-serif text-4xl sm:text-5xl mt-6">Tu cuenta ha sido eliminada</h1>
            <p className="mt-5 text-base text-[hsl(var(--muted-foreground))] leading-relaxed">Tus datos personales y contenido se han eliminado. Los registros financieros legalmente obligatorios, si existen, permanecen disociados de tu cuenta.</p>
            <Link to="/" className="mt-8 inline-flex px-6 py-3 rounded-full bg-[hsl(var(--foreground))] text-white font-semibold" data-testid="account-deleted-home-link">Volver a MIZETA</Link>
          </section>
        ) : (
          <>
            <section className="max-w-3xl fade-up">
              <p className="eyebrow mb-5">control de tus datos</p>
              <h1 className="font-serif text-4xl sm:text-5xl">Solicitar la eliminación de tu cuenta</h1>
              <p className="mt-6 text-base text-[hsl(var(--muted-foreground))] leading-relaxed max-w-2xl">La eliminación se realiza desde la sección Cuenta de MIZETA para confirmar de forma segura que eres la persona titular.</p>
            </section>

            <section className="mt-14 py-10 border-y border-[hsl(var(--border))] grid sm:grid-cols-2 gap-10">
              <div>
                <h2 className="font-serif text-2xl">Se elimina</h2>
                <ul className="mt-4 space-y-2 text-sm text-[hsl(var(--muted-foreground))]" data-testid="deleted-data-list">
                  <li>Cuenta y sesiones activas</li><li>Recetas y transcripciones</li><li>Categorías personales</li><li>Conversaciones y tickets de soporte</li>
                </ul>
              </div>
              <div>
                <h2 className="font-serif text-2xl">Conservación limitada</h2>
                <p className="mt-4 text-sm text-[hsl(var(--muted-foreground))] leading-relaxed" data-testid="retained-data-notice">Solo se conservan registros de pagos cuando exista una obligación legal. Quedan disociados de la cuenta eliminada.</p>
              </div>
            </section>

            {!loading && (
              user ? (
                <Link to="/app/cuenta" className="mt-10 inline-flex px-6 py-3 rounded-full bg-[hsl(var(--primary))] text-white font-semibold btn-press" data-testid="go-to-account-deletion-link">Ir a Cuenta para eliminarla</Link>
              ) : (
                <button onClick={loginForDeletion} className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[hsl(var(--primary))] text-white font-semibold btn-press" data-testid="login-for-account-deletion-button"><SignIn size={18} /> Iniciar sesión para eliminarla</button>
              )
            )}
          </>
        )}
      </main>
    </div>
  );
}